import { Action,action } from 'easy-peasy';
import { BuildingResultType } from '../types/BuildingFullConfigType';

export interface SitesModel {
  selectedSite: string;
  setSelectSite: Action<SitesModel, string>;
  siteServices: BuildingResultType;
  setSiteServices: Action<SitesModel, BuildingResultType>;
}

const sites: SitesModel = {
  selectedSite: 'UNDEFINED',
  siteServices: {
    intranetActif: false,
    domotique: false,
    hashPlan: '',
    bureauxDispo: false,
    laVallee: false,
    urlImage: '',
    activateBooking: false,
  },
  setSelectSite: action((state, payload) => {
    state.selectedSite = payload;
  }),
  setSiteServices: action((state, payload) => {
    state.siteServices = payload;
  }),
};

export default sites;
